import { Pipe, PipeTransform } from '@angular/core';

import { Category } from '../../categories/shared';
import { Filter } from './filter.model';

@Pipe({
  name: 'filterFilter'
})
export class FilterFilterPipe implements PipeTransform {
  transform(filters: Array<Filter>, name: string, category: String): any {
    if (filters) {
      return filters.filter((filter: Filter) => {
        let valid = true;

        if (
          (name) &&
          (filter.name.toLowerCase().lastIndexOf(name.toLowerCase(), 0) !== 0)
        ) {
          valid = false;
        }

        if (
          ((category) && (!filter.category)) ||
          ((category) && (filter.category._id !== category))
        ) {
          valid = false;
        }

        return valid;
      });
    }

    return filters;
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/filters/shared/filter-filter.pipe.ts